import { createSlice } from "@reduxjs/toolkit";

interface GlobalSliceProps {
  isLoading: boolean;
  error: boolean;
  drawerStatusStore: boolean;
  updatePageStore: boolean;
  isFormSubmitted: boolean;
  storeCHMPaginationData: Object;
  storeICVActivitiesPaginationData: Object;
  storeICVVendorPaginationData: Object;
  storeICVSurveyorPaginationData: Object;
  storeIECPaginationData: Object;
}

const initialState: GlobalSliceProps = {
  isLoading: false,
  error: false,
  drawerStatusStore: false,
  updatePageStore: false,
  isFormSubmitted: false,
  storeCHMPaginationData: {
    offset: 0,
    limit: 25,
    selectedLimit: 25,
  },
  storeICVActivitiesPaginationData: {
    offset: 0,
    limit: 250,
    selectedLimit: 250,
  },
  storeICVVendorPaginationData: {
    offset: 0,
    limit: 25,
    selectedLimit: 25,
  },
  storeICVSurveyorPaginationData: {
    offset: 0,
    limit: 25,
    selectedLimit: 25,
  },
  storeIECPaginationData: {
    offset: 0,
    limit: 25,
    selectedLimit: 25,
  },
};

export const globalSlice = createSlice({
  name: "globalDatum",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state, action) {
      state.isLoading = action.payload;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    handleDrawerStatusSlice(state, action) {
      state.drawerStatusStore = action.payload;
    },
    // Method to update page render
    handleUpdatePageSlice(state, action) {
      state.updatePageStore = action.payload;
    },

    // Method to track form submission
    handleFormSubmittedSlice(state, action) {
      state.isFormSubmitted = action.payload;
    },

    handleCHMPaginationDataSlice(state, action) {
      state.storeCHMPaginationData = action.payload;
    },

    handleICVActivitiesPaginationDataSlice(state, action) {
      state.storeICVActivitiesPaginationData = action.payload;
    },
    handleICVVendorPaginationDataSlice(state, action) {
      state.storeICVVendorPaginationData = action.payload;
    },
    handleICVSurveyorPaginationDataSlice(state, action) {
      state.storeICVSurveyorPaginationData = action.payload;
    },
    handleIECPaginationDataSlice(state, action) {
      state.storeIECPaginationData = action.payload;
    },
  },
});

export const {
  startLoading,
  hasError,
  handleDrawerStatusSlice,
  handleUpdatePageSlice,
  handleFormSubmittedSlice,
  handleCHMPaginationDataSlice,
  handleICVActivitiesPaginationDataSlice,
  handleIECPaginationDataSlice,
  handleICVVendorPaginationDataSlice,
  handleICVSurveyorPaginationDataSlice,
} = globalSlice.actions;

export default globalSlice.reducer;
